<script setup lang="ts">
  import { reactiveOmit } from '@vueuse/core';
  import type { ListboxFilterProps } from 'reka-ui';
  import { ListboxFilter, useForwardProps } from 'reka-ui';
  import type { HTMLAttributes } from 'vue';

  import { cn } from '@ui/utils/utils';

  import { useCommand } from '.';

  const props = defineProps<
    ListboxFilterProps & {
      class?: HTMLAttributes['class'];
      hideSearchIcon?: boolean;
    }
  >();

  defineOptions({
    inheritAttrs: false,
  });

  const delegatedProps = reactiveOmit(props, 'class');

  const forwardedProps = useForwardProps(delegatedProps);

  const { filterState } = useCommand();
</script>

<template>
  <div data-slot="command-input-wrapper" class="flex h-9 items-center gap-2 border-b px-3">
    <i v-if="!hideSearchIcon" class="fa fa-search text-xs opacity-50 size-4 pt-0.5" />

    <ListboxFilter
      v-bind="{ ...forwardedProps, ...$attrs }"
      v-model="filterState.search"
      data-slot="command-input"
      auto-focus
      :class="
        cn(
          'placeholder:text-muted-foreground flex h-9 py-1.5 w-full rounded-sm bg-transparent text-xs outline-hidden disabled:cursor-not-allowed disabled:opacity-50',
          props.class,
        )
      "
    />
  </div>
</template>
